<template>
  <div class="row">
    <div class="col-md-3">
      <div v-if="event.image_url" class="item-image">
        <div v-if="event.sold_out" class="item-badges">
          <div class="item-badge-left">Sold out!</div>
        </div>

        <img :src="event.image_url" class="img-fluid">
      </div>

      <div v-else class="text-center">
        <i class="fa fa-picture-o" style="font-size: 10em;" aria-hidden="true"></i>
      </div>
    </div>

    <div class="col-md-9">
      <a v-if="disableShowEventButton" href="javascript:;" class="btn btn-primary float-right">
        Show Event
      </a>
      <router-link v-else :to="{name: 'eventShow',
        params: { event: event, id: event.id, event_title: encodeEventTitle(event.title) }}"
        class="btn btn-primary float-right">
        Show Event
      </router-link>

      <h3 class="item-title">
        {{ event.title }}
        <small v-if="event.sold_out" class="sold-out">
          (Sold out!)
        </small>
      </h3>
      <div class="item-location">
        <i class="fa fa-map-marker"></i>
        <div v-html="getEventFullAddress(event)">
        </div>
      </div>
      <div class="item-actions">
        <i class="fa fa-calendar"></i>
        {{ getEventFullDateTime(event) }}
      </div>
      <div class="item-description">
        <div v-html="markedText(event.description)">
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'EventRow',
  props: {
    event: {
      required: true,
      type: Object
    },
    disableShowEventButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return { }
  },
  methods: {
    getEventDateInfo (event) {
      if (event.event_dates_attributes.length > 1) {
        return 'Multiple dates'
      } else {
        return event.event_dates_attributes[0].formatted_starts_at
      }
    }
  }
}
</script>
